export default "__VITE_ASSET__BaaDGRpl__"